export default "__VITE_ASSET__Cuvn0V6w__"